import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Tabmenu-item element, used for each individual tabmenu-item within the tabmenu element
 *
 * @prop {String} link - Used to define the link of the tabmenu-item
 * @prop {String} label - Used to define the tabmenu-item text
 * @prop {String} active - Used to display the active tabmenu-item (bold text)
 *
 */
let SDBNavTabMenuItem = class SDBNavTabMenuItem extends LitElement {
    constructor() {
        super(...arguments);
        this.link = '';
        this.active = false;
        this.label = '';
    }
    render() {
        return html `
            ${this.link && this.link.length
            ? html `<li><a href="${this.link}"> ${this.label}</a></li>`
            : html `<li>${this.label}</li>`}
        `;
    }
};
SDBNavTabMenuItem.styles = [
    elements,
    css `
            :host {
                display: inline-block;
                height: 20px;
                border-right: 1.5px solid var(--text-primary);
                line-height: 20px;
                margin: 5px 0;
                color: var(--text-primary);
            }

            :host a {
                text-decoration: none;
                color: var(--text-primary);
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */

                :host {
                    border-right: none;
                    width: 100%;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    height: 30px;
                }

                :host li {
                    text-align: left !important;
                    height: 30px;
                }
            }

            /*:host :first-of-type{
      padding-left:0;
    }*/

            :host(:last-child) {
                border-right: none;
            }
            :host li {
                display: block;
                color: var(--text-primary);
                text-align: center;
                padding: 0 20px;
                text-decoration: none;
                transition: scale 0.1s ease-in-out;
                -webkit-transform: rotateZ(360deg);
            }

            :host li:hover {
                transform: scale(1.05);
            }

            :host([active]) li {
                font-weight: 700;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBNavTabMenuItem.prototype, "link", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavTabMenuItem.prototype, "active", void 0);
__decorate([
    property()
], SDBNavTabMenuItem.prototype, "label", void 0);
SDBNavTabMenuItem = __decorate([
    customElement('sdb-nav-tabmenu-item')
], SDBNavTabMenuItem);
export { SDBNavTabMenuItem };
//# sourceMappingURL=sdb-nav-tabmenu-item.js.map